<template>
  <div class="tabs is-toggle is-small">
    <ul>
      <li
        v-for="(item, index) in tabs"
        :key="index"
        :class="{ 'is-active': item.id === activeTrackerCategory }"
      >
        <a @click="activate(item)">{{ $t(item.path) }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { map, find, assignIn } from "lodash";
import { mapState } from "vuex";

export default {
  name: "MomentTrackerTabs",

  computed: {
    ...mapState("audience", ["activeTrackerCategory"])
  },

  data() {
    return {
      tabs: [
        {
          id: "past",
          path: "audience.moment_tracker.categories.past"
        },
        {
          id: "present",
          path: "audience.moment_tracker.categories.present"
        },
        {
          id: "future",
          path: "audience.moment_tracker.categories.future"
        }
      ]
    };
  },

  methods: {
    activate(item) {
      this.$store.commit("audience/setActiveCategory", item.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  li {
    width: calc(100% / 3);

    &:first-child {
      a {
        border-radius: 4px 0 0 4px;
      }
    }

    &:last-child {
      a {
        border-radius: 0 4px 4px 0;
      }
    }
  }
}
</style>
